import { memo, useContext, useEffect } from 'react'

import dayjs from 'dayjs'
import Cookies from 'js-cookie'

import { useRouterExtend } from 'hooks/useRouterExtend'
import { INSKIN_OVULATION } from 'interfaces/constants/cookies'
import { InSkinAdLocales } from 'interfaces/constants/inSkinAdLocales'
import { AppContext } from 'state/appContext'
import { getAge } from 'utils/getAge'
import { getGender } from 'utils/getGender'

import { isDateInCycleForAd } from '../ovulationCalculator/utils'

// FOR INSKIN AD
export const InSkinScript = memo(function InSkinScriptComp() {
  const { locale } = useRouterExtend()
  const {
    state: { userInfo },
  } = useContext(AppContext)
  //https://discover.hellobacsi.com/health-tools/tinh-ngay-rung-trung-3/?result=1&mthd=1&dy=03-07-2023&le=28&prd=7&joincommunity=1

  const inskinOvulation = JSON.parse(Cookies.get(INSKIN_OVULATION) || '{}')

  useEffect(() => {
    if (userInfo?.id) {
      const enableOvulation =
        inskinOvulation?.cycle_length_days &&
        inskinOvulation?.period_duration_days &&
        !Boolean(userInfo?.is_new) &&
        isDateInCycleForAd(
          new Date(),
          dayjs(inskinOvulation.menstrual_from_date).toDate(),
          inskinOvulation.cycle_length_days,
          inskinOvulation.period_duration_days,
        )
      const googletag = window.googletag || { cmd: [] }
      googletag.cmd.push(function () {
        userInfo?.birthday &&
          googletag
            .pubads()
            .setTargeting('age', [getAge(userInfo?.birthday, 'YYYY-MM-DD')])
        googletag.pubads().setTargeting('gender', [getGender(userInfo?.gender)])
        googletag
          .pubads()
          .setTargeting('ovulation', [enableOvulation ? 'yes' : 'no'])
      })
    }
  }, [inskinOvulation, userInfo?.id, userInfo?.is_new])
  if (!InSkinAdLocales.includes(locale)) return null

  const script = `
  var fn_pageskin = "false";
  if (screen.width >= 1280) {
      fn_pageskin = "true";
  }
  window.googletag = window.googletag || { cmd: [] };
  googletag.cmd.push(function () {
    googletag.pubads().setTargeting("inskin_yes",fn_pageskin);
  });`
  return (
    <script
      id="inskin-script"
      dangerouslySetInnerHTML={{
        __html: script,
      }}
    ></script>
  )
})
